import "./LandingStyles.css";
import LandingData from "./LandingData";

function Landing (){
return (
    <div className="Header">
        <h4>Learn a little about Elevate
            
        </h4>
        

    <div className="Headercard">
        <LandingData
            icon ="fa-brands fa-pagelines"
            heading="Family Counseling and Therapy"
            text="Having an interactive session as a family"
        />

        <LandingData
            icon ="fa-solid fa-fire"
            heading="Mental Health Services"
            text="Offering a variety of mental health services"
        />
        
        <LandingData
            icon ="fa-solid fa-seedling"
            heading="Training and Workshops services"
            text="We offer training and workshops for all organizations"
        />

        
        <LandingData
            icon ="fa-solid fa-seedling"
            heading="Community Support Services"
            text="We offer training and workshops for all organizations"
        />
    </div>
    </div>
);
}

export default Landing;